import polyfills from './polyfills';
import wmndsComponents from './wmnds-components';
import customJS from './custom';

window.addEventListener('DOMContentLoaded', polyfills(), wmndsComponents(), customJS());
